// extracted by mini-css-extract-plugin
export default {"customTable":"AdminPanel_customTable__9tXWm","customCol":"AdminPanel_customCol__C52Q1","tabHeader":"AdminPanel_tabHeader__bM+DO","activeTab":"AdminPanel_activeTab__Gxl8H"};